import React from 'react'
import NextLink, { LinkProps } from 'next/link'
import styled from 'styled-components'

import { COLORS } from '~/common/globalStyles'

interface StyledProps {
  children?: React.ReactNode
  className?: string
  color?: keyof typeof COLORS
  hoverColor?: keyof typeof COLORS
  onClick?(event: React.MouseEvent<HTMLElement>): void
  style?: Record<string, string>
  nextLinkStyle?: Record<string, string>
  target?: string
  download?: string
  'data-testid'?: string
}

const LinkWrapper = styled.span<StyledProps>`
  text-decoration: none;
  outline: 0;
  color: ${({ color }) => (color ? COLORS[color] : 'inherit')};
  &:hover {
    color: ${({ hoverColor }) => (hoverColor ? COLORS[hoverColor] : 'inherit')};
  }
`

const StyledNextLink = styled(NextLink)`
  text-decoration: none;
`

export type Props = StyledProps & LinkProps

const Link = ({
  className,
  color,
  hoverColor,
  onClick,
  style,
  children,
  target,
  download,
  'data-testid': dataTestId = 'next-link',
  nextLinkStyle,
  ...rest
}: Props) => (
  <LinkWrapper
    data-testid={dataTestId}
    className={className}
    color={color}
    hoverColor={hoverColor}
    style={style}
  >
    <StyledNextLink
      {...rest}
      data-testid={`${dataTestId}-a`}
      style={nextLinkStyle}
      target={target}
      download={download}
      onClick={onClick}
    >
      {children}
    </StyledNextLink>
  </LinkWrapper>
)

export default Link
